module.exports = __webpack_public_path__ + "static/media/video.671d594a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/EnableWA/video.jpg
// module id = 236
// module chunks = 0